import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomAttributeFieldType, DialogType } from "src/app/inventory/sales-order/constants/constants";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { MyDocumentsService } from "src/app/profile/my-documents";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { IVendorRma, VendorRmaProduct } from "src/app/inventory/sales-order/models/customer-return.model";
import { Subject, forkJoin, map, takeUntil } from "rxjs";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import data from "src/app/inventory/staticJSON/settings-column.json";
import { ProductsService } from "src/app/inventory/products/products.service";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { ObjectNames, Severity, Status } from "src/app/inventory/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { OverlayPanel } from "primeng/overlaypanel";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";
@Component({
  selector: "app-vendor-return-add-edit",
  templateUrl: "./add-edit.component.html",
  styleUrls: ["./add-edit.component.scss"],
})
export class VendorReturnAddEditComponent implements OnChanges, OnInit {
  @Input() displayReturnAdd;
  @Input() type;
  @Input() dialogHeader;
  @Input() selectedVendorRenurnId;
  @Input() orgCurrency = [];
  @Input() baseCurrency: any;
  @Output() onVendorRmaSaveComplete = new EventEmitter();
  @ViewChild("fileUpload") fileUpload: any;
  @ViewChild('editCurrency') overlayPanel: OverlayPanel;
  vendorDetails: any
  // vendorExchangeRate :null
  fieldTypes = CustomAttributeFieldType;
  billItemsSection: any[] = [];
  length: number = 0;
  vendorReturnTemplate;
  customFields: any[] = [];
  trackingOptions = [];
  accountChannels = [];
  allCustomFieldTypes: any[] = [];
  allVendors: any[] = [];
  configCustomFields: any[] = [];
  applyValidation: boolean = false;
  selectedChannel;
  selectedAccount;
  allAccountsDD = [];
  searchBy = [
    { id: 1, name: "Bill No." },
    { id: 2, name: "Serial No." },
    { id: 3, name: "Item No." },
  ];
  selectedSearch;
  allReasons = [];
  uploadedFiles: any[] = [];
  purchaseListTB = [];
  subtotal = 0;
  totalRefund = 0;
  displayList = false;
  hasSelectedProduct: boolean;
  selectedLocation;
  selectedProducts = [];
  selectedBill: any;
  selectedSerialNumber: any;
  selectedItemNumber: any;
  billItems = [];
  disableBillChange: boolean = false;
  disableSerialNumberInput: boolean = false;
  disableItemNumberInput: boolean;
  selectedProductListTable = [];
  showProductChooseFooter: boolean = false;
  showAddProduct: boolean = false;
  allBills: [];
  rmaLocations = [];
  vendorReturnDetails;
  disableSaveRmaButton: boolean = true;
  discount: number = 0;
  tax: number = 0;
  shipping: number = 0;
  orderTotal: number = 0;
  totalFileSize: any;
  selectedAttachments: any = [];
  utilityServiceObj: UtilityService;
  FILE_SIZE = 5;
  MAX_SIZE = this.FILE_SIZE * 1024 * 1024; // 5MB
  allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"];
  files = [];
  uploadedAttachments: any = [];
  displayNewUpload: boolean = false;
  rmaDetailsText: string;
  serialNumberSuggestions: any[] | undefined;
  itemNumberSuggestions: any[] | undefined;
  footerColspan: any;
  totalLength: number = 0;

  footerData = {
    subtotal: this.subtotal,
    discount: this.discount,
    tax: this.tax,
    shipping: this.shipping,
    ordertotal: this.orderTotal,
    totalrefund: this.totalRefund,
  };

  // common custom attributes
  allCustomAttributes = [];
  selectedLists = [];
  allVendorsDD: any[] = [];
  allReturnTypes = [];
  returnForm: FormGroup;
  displayReturnAdd2: boolean = false;
  showBillNumber: boolean = false;
  closingDate: any;
  //tracking
  refId: string = '';
  importForAllProducts: boolean = false;
  disabledSave: boolean = false;
  displayImport: boolean = false;
  displayTracking: boolean = false;
  systemTrackingData = [];
  unMatchedSerials = [];
  serialConfig;
  displayScanInfo = false;
  allChecked = false;
  nameLists = [];
  selectedProductForScan;
  selectedBundleForScan;
  trackingForm: FormGroup;
  listLength = 0;
  productSerialSettings;
  autoGenerateLists = [];
  totalTBRecord: number = 0;
  rowsPerPageTB = [100, 200, 300, 500];
  pageSize: number = 100;
  pageNumber: number = 1;
  first: number = 0;
  isDisabledSaveBtn = false;
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  vendorreturn_other1: any[] = [];
  vendorreturn_other2: any[] = [];
  vendorreturn_other3: any[] = [];
  statementMessege: string = '';
  qtyFractionDigits: number = 0;
  measurementUnits = [];
  decimalPlacesMap: { [key: number]: number } = {};
  isAllowPostingPeriod: boolean = false;
  currentPostingPeriodInfo: IPostingPeriodDetails;
  updatedPostingPeriodInfo: IPostingPeriodDetails;
  constructor(
    private purchaseService: PurchasesService,
    private messageService: MessageService,
    public appMainService: AppMainService,
    private datepipe: DatePipe,
    public app: AppMainComponent,
    public confirmationService: ConfirmationService,
    private productsService: ProductsService,
    private salesOrderService: SalesOrderService,
    private fb: FormBuilder,
    private utilityService: UtilityService, private utilService: UtilsService,
    public documentService: MyDocumentsService,
    public titleCasePipe: TitleCasePipe,
    private importService: ImportserialService,
  ) { }

  clearRMAForm() {
    this.selectedBill = null;
    this.selectedLocation = null;
    this.selectedProductListTable = [];
    this.selectedProducts = [];
    this.uploadedAttachments = [];
    this.uploadedFiles = [];
    this.selectedAttachments = [];
    this.disableBillChange = false;
    this.showAddProduct = false;
    this.subtotal = 0;
    this.totalRefund = 0;
    this.discount = 0;
    this.tax = 0;
    this.shipping = 0;
    this.orderTotal = 0;
    this.fileUpload?.clear();
    this.updateTotals();
  }

  ngOnInit() {
    this.utilityServiceObj = this.utilityService;
    this.getDecimalValue();
    this.getQtyDecimalDigits();
    this.fetchUnitOfMeasureCategories();
    this.prepareTrackingForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadConfigurationData();
    this.disableBillChange = this.selectedProducts.length > 0;
    if (changes?.type?.currentValue) {
      this.type = changes.type.currentValue;
      if (this.type == DialogType.CREATE) {
        this.uploadedFiles = [];
        this.applyValidation = false;
        this.initReturnForm();
      } else if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
        this.applyValidation = false;
        this.initializeVendorReturn(this.selectedVendorRenurnId);
      }
    }
    if (this.type == 'CREATE') {
      this.closingDate = this.app._showDateTimeWithZone(new Date())

    }
    this.getIsetting();
  }
  getQtyDecimalDigits() {
    this.importService
      .getQtyDecimalValue()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        if (value) {
          this.qtyFractionDigits = value;
        }
      });
  }
  fetchUnitOfMeasureCategories() {
    this.salesOrderService.fetchUnitOfMeasureCategories().subscribe(resp => {
      this.measurementUnits = resp
    })
  }
  getDecimalPlacesCached(categoryId: number): number {
    if (!(categoryId in this.decimalPlacesMap)) {
      this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
    }
    return this.decimalPlacesMap[categoryId];
  }
  getDecimalPlaces(categoryId: number): number {
    return this.measurementUnits?.some(unit => unit.id === categoryId && unit.name?.toLowerCase() === 'count') ? 0 : this.qtyFractionDigits;
  }
  loadConfigurationData() {
    this.billItemsSection = data.billItemsSection;
    const purchaseObjId = this.app.preLoadedObjects.find((el) => el.name == ObjectNames.purchaseConstants.Purchase_Module_Object)?.id;
    this.appMainService.isShowSpinner("loadAllData");
    forkJoin({
      trackingOptions: this.productsService.loadTrackingOptions(),
      rmaLocations: this.salesOrderService.getRMALocations(),
      returnTypes: this.salesOrderService.getAllReturnTypes(),
      returnReasons: this.salesOrderService.getAllReturnReasons(),
      customFields: this.productsService.getAllCustomFields(purchaseObjId),
      poConfigurations: this.purchaseService.getPOConfigurations("Purchase"),
      allVendors: this.purchaseService.getAllPOVendors(),
    })
      .pipe(
        map(({ trackingOptions, rmaLocations, returnReasons, returnTypes, customFields, poConfigurations, allVendors }) => {
          this.appMainService.isHideSpinner("loadAllData");
          this.rmaTypes(returnTypes);
          this.loadRMALocation(rmaLocations);
          this.allReasons = returnReasons;
          this.customFields = customFields;
          this.trackingOptions = trackingOptions;
          const parsedConfig = JSON.parse(poConfigurations.filter((config) => config.name == "Purchase Template")[0]?.configurationDetails[0].configJSONValue);
          this.vendorReturnTemplate = parsedConfig?.filter((t) => t.templateName == "Vendorreturns_template")[0];
          this.footerColspan = this.vendorReturnTemplate?.labels_table?.filter((x) => x.isChecked)!.length + 1;
          this.allVendorsDD = allVendors?.filter((vendor) => vendor?.isActive);
          this.getCustomFieldList();
        }),
      )
      .subscribe({
        next: () => { },
        error: (err) => {
          this.appMainService.isHideSpinner("loadAllData");
          this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        },
      });
  }
  initReturnForm() {
    const iSettings = this.utilityService.getISettings();
    this.serialConfig = iSettings?.find((value) => value.code == "enableserial");
    this.returnForm = this.fb.group({
      id: [0],
      rmaTypeId: [null, [Validators.required]],
      vendorId: [null, [Validators.required]],
      warehouseId: [null, [Validators.required]],
      rmaReasonId: [null, [Validators.required]],
      description: [""],
    });
  }

  vendorSelected(e) {
    this.showAddProduct = true;
  }

  editVendorReturn(e) {
    this.type = "EDIT";
    this.dialogHeader = "Edit Vendor Return";
    this.returnForm.enable();
  }
  onSearchByChange(event) {
    this.billItems = [];
    this.selectedBill = null;
    this.selectedSerialNumber = null;
    this.selectedItemNumber = null;
    this.showBillNumber = this.selectedSearch?.name != "Bill No.";
  }

  onChangeBill(event) {
    this.billItems = [];
    this.selectedProducts = [];
    this.selectedBill = event.value;
    if (this.selectedBill?.id) {
      this.fetchBillItemsByBillId(this.selectedBill?.id);
    }
  }

  rmaTypes(res) {
    if (res) {
      this.allReturnTypes = res.filter((ele) => ele?.name != "Exchange");
      this.returnForm?.controls["rmaTypeId"]?.setValue(this.allReturnTypes?.find((type) => type?.isDefault));
    }
  }

  getDecimalValue() {
    this.importService.getDecimalValue().subscribe((value) => {
      if (value) {
        this.length = value;
      }
    });
  }


  onDialogClose() {
    this.displayReturnAdd = false;
    this.clearRMAForm();
    this.returnForm.reset();
    this.onVendorRmaSaveComplete.emit(false);
  }

  getChangeLocation() {
    this.clearRMAForm();
    this.returnForm?.controls["rmaReasonId"].setValue(null);
    this.returnForm?.controls["vendorId"].setValue(null);
  }
  getSelectedVendorDetails(vendorId) {
    this.clearRMAForm();
    this.returnForm?.controls["rmaReasonId"].setValue(null);
    this.purchaseService.getVendorById(vendorId).subscribe(value => {
      this.vendorDetails = value;
    })
  }
  get vendorExchangeRate() {

    return (this.orgCurrency?.find(cr => cr.currencyId == this.vendorDetails?.currencyId)?.exchangeRate);
  }
  onUpload(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    this.messageService.add({ severity: "info", summary: "File Uploaded", detail: "" });
  }

  onChangeAccountChannel() {
    this.selectedAccount = null;
  }

  removeProduct(index) {
    const stop = this.selectedProductListTable.length - 1;
    while (index < stop) {
      this.selectedProductListTable[index] = this.selectedProductListTable[++index];
    }
    this.selectedProductListTable.pop();
    this.selectedProducts = JSON.parse(JSON.stringify(this.selectedProductListTable));
    this.calculateSubTotalAmount();
    this.calculateTotalRefundAmount();
    this.updateTotals();
    this.toggleBillDropdown(null);
  }

  toggleBillDropdown(event) {
    this.hasSelectedProduct = this.selectedProducts.length > 0;
    this.disableBillChange = this.hasSelectedProduct;
    this.disableSerialNumberInput = this.hasSelectedProduct;
    this.disableItemNumberInput = this.hasSelectedProduct;
    this.showProductChooseFooter = this.selectedProducts.length > 0;
  }

  filterAccount(event) {
    let query = event.query;
    const typeId = this.selectedChannel?.id;
    query = event.query;
    this.salesOrderService.getAccountsByChannelId(typeId, query.toLowerCase()).subscribe((res: any) => {
      const filtered: any[] = [];
      if (res?.length > 0) {
        this.allVendorsDD = res.filter((r) => r.statusId == Status.Active);
      }
    });
  }

  loadRMALocation(res) {
    this.rmaLocations = [];
    if (res && res.length > 0) {
      this.rmaLocations = res?.map((location) => ({ ...location, label: `${location.locationId} - ${location.name}` }));
      if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
        const filteredWarehouseId = this.rmaLocations?.find((loc) => loc?.id == this.vendorReturnDetails?.warehouseId);
        this.returnForm?.controls["warehouseId"].setValue(filteredWarehouseId);
        this.selectedLocation = filteredWarehouseId;
      } else {
        const filteredWarehouseId = this.rmaLocations?.find((loc) => loc?.isRMAWarehouse);
        this.returnForm?.controls["warehouseId"].setValue(filteredWarehouseId);
      }
    }
  }
  locationChanged(event) {
    this.selectedLocation.id = this.returnForm?.controls?.["warehouseId"].value?.id;
    this.selectedBill = null;
    if (this.selectedLocation && this.returnForm?.controls?.["vendorId"].value) {
      this.showAddProduct = true;
    } else {
      this.showAddProduct = false;
    }
    this.selectedProductListTable = [];
    this.loadBills(this.returnForm?.controls?.["vendorId"].value?.id, this.selectedLocation?.id);
  }
  uploadAttachments(event) {
    this.createUpdateFolderFiles();
  }
  downloadFile(filePath) {
    window.open(filePath);
  }
  removeSelectedAttachment(event) {
    const index = this.selectedAttachments?.indexOf(event.file, 0);
    if (index > -1) {
      this.selectedAttachments?.splice(index, 1);
    }
  }

  setFormData(files): any {
    const formData = new FormData();
    for (let file of files) {
      formData.append("Files", file);
    }
    return formData;
  }
  deleteImage(imageId) {
    this.uploadedFiles?.forEach((element) => {
      if (element.attachmentId == imageId) {
        const index = this.uploadedFiles?.indexOf(element);
        this.uploadedFiles?.splice(index, 1);
      }
    });
  }
  createUpdateFolderFiles() {
    if (this.totalFileSize > this.MAX_SIZE) {
      this.messageService.add({
        severity: Severity.Warn,
        summary: "Maximum Upload Size Limit Exceeded",
        detail: "Maximum upload size is 5MB!",
      });
      return;
    }

    const formData = this.setFormData(this.selectedAttachments);
    formData.append("ModuleNameWithDisplayOrder", "VendorRMA-1");
    this.uploadedAttachments = [];
    this.appMainService.isShowSpinner("uplaodFile");
    this.documentService.uploadFilesByOrganization(formData).subscribe({
      next: (data) => {
        this.uploadedAttachments.push(...data);
        this.displayNewUpload = false;
        this.appMainService.isHideSpinner("uplaodFile");
        this.messageService.add({
          severity: Severity.Success,
          summary: this.titleCasePipe.transform(Severity.Success),
          detail: "Saved Successfully ...",
        });
      },
      error: (error) => {
        this.appMainService.isHideSpinner("uplaodFile");
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titleCasePipe.transform(Severity.Error),
          detail: "Error occurred ...",
        });
      },
    });
  }

  isClosingStatementDate(event: string) {
    this.statementMessege = event;
  }

  saveSelectedAttachments(event) {
    for (let file of event.files) {
      this.totalFileSize += file.size;
      this.selectedAttachments.push(file);
    }

    this.messageService.add({
      severity: "info",
      summary: "Attachemnt selected",
      detail: "Please upload before you save the Vendor return",
    });
  }

  loadBills(vendorId, locationId) {
    this.purchaseService.getAllBillsByVendorId(vendorId, locationId).subscribe((resp) => {
      if (resp) {
        this.allBills = resp.map((x) => {
          return { ...x, name: x.number };
        });
      }
      if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
        this.selectedBill = this.allBills?.find((bill: any) => bill?.id == this.vendorReturnDetails?.billOrderId);
      }
      if (this.selectedBill) {
        this.fetchBillItemsByBillId(this.selectedBill?.id);
      }
      this.displayList = true;
    });
  }

  fetchBillItemsByBillId(billId: number) {
    this.purchaseService.getBillOrderItemsByBillId(this.returnForm?.controls["vendorId"].value?.id, billId).subscribe((resp) => {
      this.PrepareBillItems(resp);
    });
  }

  PrepareBillItems(response: any, type?): void {
    if (response?.billProducts) {
      this.billItems = response?.billProducts.map((ele) => ({
        ...ele,
        rate: ele?.rate !== undefined ? parseFloat(ele?.rate).toFixed(this.length) : ele?.rate,
        amount: ele?.amount !== undefined ? parseFloat(ele?.amount).toFixed(this.length) : ele?.amount,
        originalPrice: ele?.originalPrice !== undefined ? parseFloat(ele?.originalPrice).toFixed(this.length) : ele?.originalPrice,
        discountPerPrice: ele?.discountPerPrice !== undefined ? parseFloat(ele?.discountPerPrice).toFixed(this.length) : ele?.discountPerPrice,
        // this is  Serial number comes from bill but  added for vendor return so first time we add the id 0
        vendorRMAProductSerialDetail: ele?.billOrderSerialDetail?.map((item) => {
          let newItem = { ...item };
          if ("id" in newItem) {
            newItem.id = 0;
          }
          newItem.vendorRMAId = 0;
          return newItem;
        }),
      }));

      if (type) {
        this.selectedBill = this.allBills?.find((bill: any) => bill?.id == response?.billProducts[0]?.billOrderId);
      }
      this.subtotal = response?.subTotal.toFixed(this.length);
    }
  }


  showList() {
    this.selectedLists = [...this.purchaseListTB];
    this.displayList = true;
  }

  fetchBillItemsBySerialNumber(serialNumber: string) {
    this.purchaseService.getBillOrderItemsBySerialNumber(this.returnForm?.controls?.["vendorId"]?.value?.id, this.returnForm?.controls?.["warehouseId"].value?.id, serialNumber).subscribe((res) => {
      this.PrepareBillItems(res, "serial");
    });
  }

  onSerialNumberInput(event) {
    const serialNumber = event.query;
    this.purchaseService.getSerialNumbers(this.returnForm?.controls?.["vendorId"]?.value?.id, this.returnForm?.controls?.["warehouseId"].value?.id, serialNumber).subscribe((res) => {
      if (res) {
        this.serialNumberSuggestions = res;
      }
    });
  }

  onSerialNumberBillSelect(value) {
    this.selectedSerialNumber = value;
    if (value) {
      this.fetchBillItemsBySerialNumber(value);
    }
  }

  onItemNumberBillSelect(value) {
    this.selectedItemNumber = value;
    this.fetchBillsItemsByItemNumber(value);
  }

  fetchBillsItemsByItemNumber(itemNumber: string) {
    this.purchaseService.getBillOrderItemsByItemNumber(this.returnForm?.controls?.["vendorId"].value?.id, this.returnForm?.controls?.["warehouseId"].value?.id, itemNumber).subscribe((res) => {
      this.PrepareBillItems(res, "item");
    });
  }

  onItemNumberInput(event) {
    const itemNumber = event.query;
    this.purchaseService.getItemNumbers(this.returnForm?.controls?.["vendorId"]?.value?.id, this.returnForm?.controls?.["warehouseId"].value?.id, itemNumber).subscribe((res) => {
      if (res) {
        this.itemNumberSuggestions = res;
      }
    });
  }

  saveList() {
    this.selectedProductListTable = [...this.selectedProducts].map((ele) => ({
      ...ele,
      rate: ele?.rate !== undefined ? parseFloat(ele?.rate).toFixed(this.length) : ele?.rate,
      amount: ele?.amount !== undefined ? parseFloat(ele?.amount).toFixed(this.length) : ele?.amount,
      returnAmount: ele?.returnAmount !== undefined ? parseFloat(ele?.returnAmount).toFixed(this.length) : ele?.returnAmount,
    }));
    this.calculateSubTotalAmount();
    this.calculateTotalRefundAmount();
    this.updateTotals();
    this.displayList = false;
    this.toggleBillDropdown(null);
    this.disableSaveRmaButton = this.selectedProductListTable.length == 0;
  }
  roundToTwoDecimal(data: number) {
    return Math.round(((data) + Number.EPSILON) * 100) / 100;
  }
  calculateSubTotalAmount() {
    this.subtotal = 0;
    for (let prd of this.selectedProductListTable) {
      this.subtotal += this.roundToTwoDecimal(Number(prd.returnAmount));
    }
    this.subtotal = +this.subtotal.toFixed(this.length);
  }
  calculateTotalRefundAmount() {
    this.totalRefund = 0;

    this.selectedProductListTable?.forEach((e) => (this.totalRefund += this.roundToTwoDecimal(Number(e.returnAmount))));
    this.totalRefund = this.roundToTwoDecimal(this.totalRefund);
    this.footerData["totalrefund"] = +this.totalRefund.toFixed(this.length);
  }

  updateTotals() {
    this.footerData.subtotal = this.subtotal;
    this.footerData.discount = -this.discount;
    this.footerData.tax = -this.tax;
    this.footerData.shipping = -this.shipping;
    this.footerData.ordertotal = this.orderTotal;
    this.footerData.totalrefund = +this.totalRefund.toFixed(this.length);
  }
  showProductList(vendorId, locationId) {
    this.selectedSearch = this.searchBy[0];
    this.displayList = true;
    // this.selectedBill = null;
    this.selectedSerialNumber = null;
    this.selectedItemNumber = null;
    if (vendorId) {
      this.billItems = [];
      this.selectedProducts = JSON.parse(JSON.stringify(this.selectedProductListTable));
      this.hasSelectedProduct = this.selectedProducts.length > 0;
      this.disableBillChange = this.hasSelectedProduct;
      this.disableSerialNumberInput = this.hasSelectedProduct;
      this.disableItemNumberInput = this.hasSelectedProduct;
      this.showProductChooseFooter = this.selectedProducts.length > 0;
      this.loadBills(vendorId, locationId);
    } else {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please select proper vendor information",
      });
    }
  }
  /**tracking SerialNo**/
  prepareTrackingForm() {
    const qty = this.selectedProductForScan?.returnQty;
    this.trackingForm = this.fb.group({
      qty: [(qty - this.listLength), [Validators.required]],
      lotNo: [""],
      revisionNo: [""],
      expiration: [""],
      serialNo: [""],
      serialNo2: [""],
      serialNo3: [""],
      serialNo4: [""],
      serialNo5: [""],
      serialNo6: [""],
      serialNo7: [""],
      serialNo8: [""],
      serialNo9: [""],
      serialNo10: [""],
      serialNo11: [""],
      serialNo12: [""],
      serialNo13: [""],
      serialNo14: [""],
      serialNo15: [""],
      serialNo16: [""],
      serialNo17: [""],
      packageBarcode: [""],
    });
    /**set validation for Tracking form**/
    for (let opt of this.trackingOptions) {
      if (opt.enabled && (this.productSerialSettings ? this.productSerialSettings[`${opt.code}`] : true)) {
        if (opt.field !== "serialNo" && opt.isRequired) {
          this.trackingForm?.get(`${opt.field}`).setValidators(Validators.required);
        } else if (opt.field === "serialNo" && opt.isRequired) {
          if (this.utilityService.displayName("serializedChecked", this.trackingOptions, "control") == "InputBox") {
            this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
          } else {
            this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required]);
          }
        } else {
          this.trackingForm?.get(`${opt.field}`).clearValidators();
        }
        this.trackingForm?.get(`${opt.field}`).updateValueAndValidity();
      }
    }
  }

  countNameList(value) {
    if (this.trackingForm?.valid && this.listLength < this.selectedProductForScan?.returnQty) {
      if (value.serialNo) {
        const duplicate = this.autoGenerateLists?.filter(sr => sr.serialNo == value.serialNo);
        if (duplicate?.length > 0) {
          this.messageService.add({
            severity: 'error', summary: 'Error',
            detail: "Serial No you tried to enter is already present in below list.",
          });
        } else {
          const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == value.serialNo);
          if (present) {
            value.systemPresent = true;
            value.remove = false;
            value.checked = false;
            this.autoGenerateLists.push(value);
            this.nameLists = this.autoGenerateLists?.slice(0, 100);
            this.listLength = this.listLength + 1;
            this.totalTBRecord = this.listLength;
            const returnQty = this.selectedProductForScan.returnQty;
            this.trackingForm.controls['qty'].setValue(returnQty - this.listLength);
          } else {
            this.checkSerialsForSystem(this.trackingForm?.controls?.["serialNo"].value, this.selectedProductForScan?.productId, this.returnForm?.controls?.["warehouseId"].value?.id, value);
          }
          const dataString = this.autoGenerateLists.map(dt => dt.serialNo).join(',');
          const dataStringArray = dataString.split(',');
          this.checkTrackingDataInSystem(this.selectedProductForScan?.productId,
            this.returnForm?.controls?.["warehouseId"].value?.id,this.selectedProductForScan.billOrderId,'serialNo',dataStringArray);
        }
      } else if (!value.serialNo) {
        const totalQty = this.selectedProductForScan?.returnQty;
        for (let i = 0; i < (value.qty); i++) {
          if (this.listLength < totalQty) {
            this.autoGenerateLists.push({ ...value });
            this.listLength++;
          }
        }
        this.totalTBRecord = this.listLength;
        this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
        const refField = this.trackingOptions?.find((el) => (el.isReference))?.field;
        const dataString = this.autoGenerateLists.map(dt => dt[refField]).join(',');
        const dataStringArray = dataString.split(',');
        this.checkTrackingDataInSystem(this.selectedProductForScan?.productId,
          this.returnForm?.controls?.["warehouseId"].value?.id,this.selectedProductForScan.billOrderId,refField,dataStringArray);
      }
    }
    const controlNames = Object.keys(this.trackingForm.controls);
    for (let ctrl of controlNames) {
      if (this.trackingOptions?.find((el) => (el.field === ctrl))?.clearField) {
        this.trackingForm.controls[`${ctrl}`].setValue("");
      }
    }
  }

  checkSerialsForSystem(serialNo, productIds, warehouseId, value) {
    this.purchaseService
      .checkSerialNoInVendorRMASystem(serialNo, warehouseId, productIds, this.vendorReturnDetails?.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((res) => {
        if (!this.serialConfig?.childInventorySettings[0]?.enabled) {
          if (res.allowSave && !res.isMatched && res.message) {
            //used in invoice then allowSave is true
            value.systemPresent = false;
            value.remove = false;
            value.checked = true;
            this.autoGenerateLists.push(value);
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength = this.listLength + 1;
            this.totalTBRecord = this.listLength;
            const returnQty = this.selectedProductForScan.returnQty;
            this.trackingForm.controls['qty'].setValue(returnQty - this.listLength);
            this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
          } else if (!res.allowSave && !res.isMatched && !res.message) {
            // if we add randamly add text then  allowSave is false and that time no any messege
            value.systemPresent = false;
            value.checked = true;
            value.remove = true;
            this.autoGenerateLists.push(value);
            this.unMatchedSerials.push(value);
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength++;
            this.totalTBRecord = this.listLength;
            const returnQty = this.selectedProductForScan.returnQty;
            this.trackingForm.controls['qty'].setValue(returnQty - this.listLength);
          }
          else if (!res.allowSave || !res.isMatched) {
            this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
          } else {
            this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is not a part of this order and associated with other product,you can't add." });
          }
        }
        else if (res.allowSave && !res.isMatched && res.message) {
          //if  this serial use in invoive then we need to show unmatch although confi side unable/disable
          value.systemPresent = false;
          value.remove = false;
          value.checked = true;
          this.autoGenerateLists.push(value);
          this.nameLists = this.autoGenerateLists.slice(0, 100);
          this.listLength = this.listLength + 1;
          const returnQty = this.selectedProductForScan.returnQty;
          this.trackingForm.controls['qty'].setValue(returnQty - this.listLength);
          this.totalTBRecord = this.listLength;
          this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
        }
        else {
          //auto-remove unmatched while save button
          value.systemPresent = false;
          value.checked = true;
          value.remove = true;
          this.autoGenerateLists.push(value);
          this.unMatchedSerials.push(value);
          this.nameLists = this.autoGenerateLists.slice(0, 100);
          this.listLength++;
          const returnQty = this.selectedProductForScan.returnQty;
          this.trackingForm.controls['qty'].setValue(returnQty - this.listLength);
          this.totalTBRecord = this.listLength;
        }
      });
  }

  deleteAll() {
    this.autoGenerateLists = [];
    this.nameLists = [];
    this.unMatchedSerials = [];
    this.listLength = 0;
    this.totalTBRecord = 0;
    const returnQty = this.selectedProductForScan.returnQty;
    this.trackingForm.controls['qty'].setValue(returnQty);
  }

  loadSerialsLazy(event) {
    if (this.autoGenerateLists) {
      this.nameLists = this.autoGenerateLists.slice(event.first, event.first + event.rows);
    }
  }

  async getCustomFieldList(action?) {
    this.vendorreturn_other1 = [];
    this.vendorreturn_other2 = [];
    this.vendorreturn_other3 = [];
    this.configCustomFields = this.customFields;
    this.configCustomFields?.forEach((fld) => {
      if (fld.isDelete && fld.section?.name) {
        let check = false;
        switch (fld.section.code) {
          case "labels_vendorreturns_other1":
            check = this.vendorReturnTemplate?.labels_vendorreturns_other1?.find((el) => el.code == fld?.name && el.sectionId == fld.section.id)?.isChecked;
            fld.isChecked = check;
            if (check) {
              if (fld.formControl?.name == "FileUpload") {
                fld.customUploadedFiles = [];
              } else if (fld.formControl?.name == "Picture") {
                fld.customUploadedFiles = [];
              } else if (fld.formControl?.name == "DatePicker") {
                fld.value = this.datepipe.transform(new Date(), "MM/dd/yyyy");
              } else if (fld.formControl?.name == "ToggleButton") {
                fld.value = false;
              }
              fld.labelname = this.vendorReturnTemplate?.labels_vendorreturns_other1?.find((el) => el.code == fld?.name && el.sectionId == fld.section?.id)?.labelname;
              this.vendorreturn_other1.push(fld);
              this.vendorreturn_other1 = this.vendorreturn_other1.map((obj) => {
                const newObj = { ...obj };

                if ("value" in newObj) {
                  delete newObj.value;
                }

                return newObj;
              });
            }

            break;
          case "labels_vendorreturns_other2":
            check = this.vendorReturnTemplate?.labels_vendorreturns_other2?.find((el) => el.code == fld?.name && el.sectionId == fld.section.id)?.isChecked;
            if (check) {
              fld.isChecked = check;
              if (fld.formControl?.name == "FileUpload") {
                fld.customUploadedFiles = [];
              } else if (fld.formControl?.name == "Picture") {
                fld.customUploadedFiles = [];
              } else if (fld.formControl?.name == "DatePicker") {
                fld.value = this.datepipe.transform(new Date(), "MM/dd/yyyy");
              } else if (fld.formControl?.name == "ToggleButton") {
                fld.value = false;
              }
              fld.labelname = this.vendorReturnTemplate?.labels_vendorreturns_other2?.find((el) => el.code == fld?.name && el.sectionId == fld.section?.id)?.labelname;
              this.vendorreturn_other2.push(fld);
              this.vendorreturn_other2 = this.vendorreturn_other2.map((obj) => {
                const newObj = { ...obj };

                if ("value" in newObj) {
                  delete newObj.value;
                }

                return newObj;
              });
            }
            break;
          case "labels_vendorreturns_other3":
            check = this.vendorReturnTemplate?.labels_vendorreturns_other3?.find((el) => el.code == fld.name && el.sectionId == fld.section.id)?.isChecked;
            if (check) {
              fld.isChecked = check;
              if (fld.formControl?.name == "FileUpload") {
                fld.customUploadedFiles = [];
              } else if (fld.formControl?.name == "Picture") {
                fld.customUploadedFiles = [];
              } else if (fld.formControl?.name == "DatePicker") {
                fld.value = this.datepipe.transform(new Date(), "MM/dd/yyyy");
              } else if (fld.formControl?.name == "ToggleButton") {
                fld.value = false;
              }
              fld.labelname = this.vendorReturnTemplate?.labels_vendorreturns_other3?.find((el) => el.code == fld?.name && el.sectionId == fld.section?.id)?.labelname;
              this.vendorreturn_other3.push(fld);
              this.vendorreturn_other3 = this.vendorreturn_other3.map((obj) => {
                const newObj = { ...obj };

                if ("value" in newObj) {
                  delete newObj.value;
                }

                return newObj;
              });
            }
            break;
          default:
            break;
        }
      }
    });
    if (action == "edit") {
      this.vendorreturn_other1?.forEach((element) => {
        const filteredCustom = this.vendorReturnDetails.customAttributeValues?.filter((c) => c.customAttributeId == element.id)[0];

        if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "InputBox" || filteredCustom.customAttribute?.formControl?.name == "Decimal" || filteredCustom.customAttribute?.formControl?.name == "Number")) {
          element.value = filteredCustom.value;
        } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
          element.customUploadedFiles = [];
          filteredCustom.customeAttachement?.forEach((el) => {
            element.customUploadedFiles.push(el);
          });
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
          element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
          element.value = filteredCustom.ratingId;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
          element.value = filteredCustom.toggle;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
          element.value = filteredCustom.values;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
          element.value = filteredCustom.values?.name;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
          element.value = [];
          filteredCustom.multipleValues?.forEach((el) => {
            element.value.push(el?.name);
          });
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
          element.value = [];
          filteredCustom.multipleValues?.forEach((el) => {
            element.value.push(el);
          });
        }
      });
      this.vendorreturn_other2?.forEach((element) => {
        const filteredCustom = this.vendorReturnDetails.customAttributeValues?.filter((c) => c.customAttributeId == element.id)[0];

        if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "InputBox" || filteredCustom.customAttribute?.formControl?.name == "Decimal" || filteredCustom.customAttribute?.formControl?.name == "Number")) {
          element.value = filteredCustom.value;
        } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
          element.customUploadedFiles = [];
          filteredCustom.customeAttachement?.forEach((el) => {
            element.customUploadedFiles.push(el);
          });
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
          element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
          element.value = filteredCustom.ratingId;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
          element.value = filteredCustom.toggle;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
          element.value = filteredCustom.values;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
          element.value = filteredCustom.values?.name;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
          element.value = [];
          filteredCustom.multipleValues?.forEach((el) => {
            element.value.push(el?.name);
          });
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
          element.value = [];
          filteredCustom.multipleValues?.forEach((el) => {
            element.value.push(el);
          });
        }
      });

      this.vendorreturn_other3?.forEach((element) => {
        const filteredCustom = this.vendorReturnDetails.customAttributeValues?.filter((c) => c.customAttributeId == element.id)[0];

        if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "InputBox" || filteredCustom.customAttribute?.formControl?.name == "Decimal" || filteredCustom.customAttribute?.formControl?.name == "Number")) {
          element.value = filteredCustom.value;
        } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
          element.customUploadedFiles = [];
          filteredCustom.customeAttachement?.forEach((el) => {
            element.customUploadedFiles.push(el);
          });
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
          element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
          element.value = filteredCustom.ratingId;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
          element.value = filteredCustom.toggle;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
          element.value = filteredCustom.values;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
          element.value = filteredCustom.values?.name;
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
          element.value = [];
          filteredCustom.multipleValues?.forEach((el) => {
            element.value.push(el?.name);
          });
        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
          element.value = [];
          filteredCustom.multipleValues?.forEach((el) => {
            element.value.push(el);
          });
        }
      });
    }
    this.totalLength = this.vendorreturn_other1.length + this.vendorreturn_other2.length + this.vendorreturn_other3.length;
  }

  isNumberKey(evt) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  onCustomUpload(files: File[], field, instance) {
    //this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors: any[] = [];
        errors = validateFiles(file, 4, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: error.fileName + ": " + error.error,
            });
          }
          //this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              name: name,
              content: content,
              extension: extension,
              sizeInBytes: size,
            };
            field.customUploadedFiles.push(attachment);
          });
        }
      }
      instance.clear();
    } else {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
      });
    }
  }

  deleteFile(field, index) {
    field?.customUploadedFiles.splice(index, 1);
  }

  checkRequired(name, cf_list) {
    return cf_list.find((el) => el?.name === name)?.isRequired || false;
  }

  setTogleValue(field, event) {
    field.value = event.checked;
  }

  openScanInfo(product) {
    this.allChecked = false;
    this.importForAllProducts = false;
    this.displayTracking = false;
    this.listLength = 0;
    this.refId = '';
    this.nameLists = [];
    this.unMatchedSerials = [];
    this.autoGenerateLists = [];
    this.selectedProductForScan = JSON.parse(JSON.stringify(product));
    this.productSerialSettings = product.trackingSetting ? JSON.parse(product?.trackingSetting) : null;
    this.selectedBundleForScan = null;
    this.prepareTrackingForm();
    this.displayScanInfo = true;
    const data = product.vendorRMAProductSerialDetail?.length > 0 ? product?.vendorRMAProductSerialDetail[0] : null;
    this.trackingForm.patchValue({
      lotNo: data?.lotNumber ?? "",
      revisionNo: data?.revisionNumber ?? "",
      expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
    });
    const arr = [];
    if (product.vendorRMAProductSerialDetail?.length > 0) {
      product.vendorRMAProductSerialDetail?.forEach((element) => {
        const obj = {
          id: element.id,
          serialNo: element.barcode,
          serialNo2: element.serialNumber2,
          serialNo3: element.serialNumber3,
          serialNo4: element.serialNumber4,
          serialNo5: element.serialNumber5,
          serialNo6: element.serialNumber6,
          serialNo7: element.serialNumber7,
          serialNo8: element.serialNumber8,
          serialNo9: element.serialNumber9,
          serialNo10: element.serialNumber10,
          serialNo11: element.serialNumber11,
          serialNo12: element.serialNumber12,
          serialNo13: element.serialNumber13,
          serialNo14: element.serialNumber14,
          serialNo15: element.serialNumber15,
          serialNo16: element.serialNumber16,
          serialNo17: element.serialNumber17,
          lotNo: element.lotNumber,
          revisionNo: element.revisionNumber,
          expiration: element.expirationDate,
          systemPresent: element.systemPresent
        };
        arr.push(obj);
      });
    }
    this.autoGenerateLists = arr;
    this.listLength = this.autoGenerateLists.length;
    this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.returnQty - this.listLength);
    this.totalTBRecord = this.listLength;
    this.checkSerialNoInSystem(this.selectedProductForScan?.productId, this.returnForm?.controls?.["warehouseId"].value?.id, this.selectedProductForScan?.billOrderId);
    // Apply the custom validator after initializing the form
    if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
      this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator([
        'lotNo', 'revisionNo', 'expiration',
        'serialNo', 'serialNo2', 'serialNo3', 'serialNo4', 'serialNo5',
        'serialNo6', 'serialNo7', 'serialNo8', 'serialNo9', 'serialNo10',
        'serialNo11', 'serialNo12', 'serialNo13', 'serialNo14', 'serialNo15',
        'serialNo16', 'serialNo17'
      ]));
      this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
    }
  }

  saveSerializedNo(c) {
    if (this.serialConfig?.childInventorySettings[0]?.enabled && this.unMatchedSerials?.length > 0) {
      this.autoGenerateLists = this.autoGenerateLists?.filter(serial => !serial.remove);
    }
    this.autoGenerateLists = this.autoGenerateLists?.filter(serial => !serial.remove);
    this.selectedProductListTable?.forEach((element) => {
      if (element.id == this.selectedProductForScan.id) {
        element.vendorRMAProductSerialDetail = [];
        this.autoGenerateLists?.forEach((nl) => {
          const obj = {
            id: this.type == DialogType.EDIT ? (nl.id ?? 0) : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.userId,
            updatedBy: this.app.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            vendorRMAId: this.type == DialogType.EDIT ? this.vendorReturnDetails?.id : 0,
            RMAProductId: this.selectedProductForScan.id,
            barcode: nl.serialNo,
            serialNumber2: nl.serialNo2,
            serialNumber3: nl.serialNo3,
            serialNumber4: nl.serialNo4,
            serialNumber5: nl.serialNo5,
            serialNumber6: nl.serialNo6,
            serialNumber7: nl.serialNo7,
            serialNumber8: nl.serialNo8,
            serialNumber9: nl.serialNo9,
            serialNumber10: nl.serialNo10,
            serialNumber11: nl.serialNo11,
            serialNumber12: nl.serialNo12,
            serialNumber13: nl.serialNo13,
            serialNumber14: nl.serialNo14,
            serialNumber15: nl.serialNo15,
            serialNumber16: nl.serialNo16,
            serialNumber17: nl.serialNo17,
            systemPresent: nl.systemPresent,
            lotNumber: nl.lotNo,
            revisionNumber: nl.revisionNo,
            expirationDate: nl.expiration ? this.app._saveDateTimeWithZone(new Date(nl.expiration)) : null,
            statusId: 1,
            referenceId: this.refId
          };
          element.vendorRMAProductSerialDetail.push(obj);
        });
      }
    });
    this.selectedProductForScan = null;
    this.selectedBundleForScan = null;
    this.displayScanInfo = false;
  }

  //tracking
  checkSerialNoInSystem(productId, warehouseId, billId) {
    this.purchaseService.checkSerialNoInVendorReturnSystem(warehouseId, productId, billId, this.vendorReturnDetails?.id).subscribe((data) => {
      this.systemTrackingData = data;
      this.autoGenerateLists = this.autoGenerateLists?.slice(0, 100)?.map(name => {
        const isPresent = this.systemTrackingData?.some(item => item?.serialNo == name?.serialNo);
        return {
          ...name,
          systemPresent: isPresent
        };
      });
      this.nameLists = this.autoGenerateLists
    });
  }

  checkTrackingDataInSystem(productId, warehouseId, billOrderId, refField, dataString) {
    this.purchaseService.checkSystemTrackingData(productId, warehouseId, billOrderId, refField, dataString, true).subscribe((data) => {
      this.autoGenerateLists = this.autoGenerateLists.map(existingItem => {
        const updatedItem = data.find(d => d[refField] === existingItem[refField] && d.systemPresent);
        return updatedItem ?? existingItem;
      });
      this.nameLists = this.autoGenerateLists.splice(0, 100);
    });
  }

  checkCustomValidation() {
    const requiredFields: any[] = [];
    this.vendorreturn_other1?.forEach((element) => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendorreturn_other2?.forEach((element) => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendorreturn_other3?.forEach((element) => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });

    const nullValue: any[] = [];
    requiredFields?.forEach((element) => {
      if ((element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") && element.customUploadedFiles.length == 0) {
        nullValue.push(element);
      }
    });
    requiredFields?.forEach((element) => {
      if (element.formControl?.name != "FileUpload" && element.formControl?.name != "Picture" && element.formControl?.name != "ToggleButton" && (element.value == null || element.value == "")) {
        nullValue.push(element);
      }
    });

    if (nullValue.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  save(value) {
    if (this.checkCustomValidation()) {
      this.applyValidation = true;
      return this.messageService.add({ severity: "error", summary: "Error", detail: "Please fill all required fields." });
    }
    const customattributeList: any[] = [];
    if (this.vendorreturn_other1.length > 0) {
      this.vendorreturn_other1?.forEach((element) => {
        if ((element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") && element.customUploadedFiles.length > 0) {
          customattributeList.push(element);
        } else if (element.value) {
          customattributeList.push(element);
        }
      });
    }
    if (this.vendorreturn_other2.length > 0) {
      this.vendorreturn_other2?.forEach((element) => {
        if ((element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") && element.customUploadedFiles.length > 0) {
          customattributeList.push(element);
        } else if (element.value) {
          customattributeList.push(element);
        }
      });
    }

    if (this.vendorreturn_other3.length > 0) {
      this.vendorreturn_other3?.forEach((element) => {
        if ((element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") && element.customUploadedFiles.length > 0) {
          customattributeList.push(element);
        } else if (element.value) {
          customattributeList.push(element);
        }
      });
    }
    this.customFields = customattributeList;

    if (this.selectedAttachments?.length > this.uploadedAttachments?.length) {
      this.confirmationService.confirm({
        message: "You have not uploaded all the selected attachments. Do you want to continue?",
        header: "Vendor RMA Create Confirmation",
        icon: "pi pi-info-circle",
        accept: () => {
          this.createVRMA(value);
        },
        reject: () => { },
      });
    } else {
      this.createVRMA(value);
    }
  }

  createVRMA(value) {
    const isValid = this.validateVRMA(this.selectedProductListTable);
    const customFields = this.customFields?.reduce((acc, item) => {
      const sectionName = item.section?.name;
      if (!acc[sectionName]) {
        acc[sectionName] = [];
      }

      acc[sectionName].push(item);

      return acc;
    }, {});

    const customAttributeList = this.utilityService.getCustomAttributesForAddEdit(customFields);
    if (!isValid) {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please create vendor Return with return qty greater than 0.",
      });
      return;
    }
    if (this.type == DialogType.CREATE) {
      this.addNewVendorReturn(value, customAttributeList);
    } else if (this.type == DialogType.EDIT) {
      this.updateVendorReturn(value, customAttributeList);
    } else {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please fill up all required fields",
      });
    }
  }
  validateVRMA(productList) {
    for (let prd of productList) {
      if (!prd.returnQty || Number(prd.returnQty) == 0) {
        return false;
      } else {
        return true;
      }
    }
  }

  addNewVendorReturn(value, customAttributes) {
    this.isDisabledSaveBtn = true;
    const rmaData = this.getVendorReturnCreateModel(value, customAttributes);
    this.appMainService.isShowSpinner("loadVendorReturn");
    const isBaseCurrency = this.baseCurrency?.currencyId == this.vendorDetails?.currencyId;
    this.purchaseService
      .createVendorReturn(isBaseCurrency, rmaData)
      .then(() => {
        this.appMainService.isHideSpinner("loadVendorReturn");
        this.isDisabledSaveBtn = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Vendor return saved successfully",
        });
        this.onVendorRmaSaveComplete.emit(true);
      })
      .catch(() => {
        this.isDisabledSaveBtn = false;
        this.appMainService.isHideSpinner("loadVendorReturn");
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error occurred while saving vendor return",
        });
      });
  }

  updateVendorReturn(value, customAttributeList) {
    this.isDisabledSaveBtn = true;
    const isBaseCurrency = this.baseCurrency?.currencyId == this.vendorDetails?.currencyId;
    let rmaData = this.getVendorReturnCreateModel(value, customAttributeList);
    this.appMainService.isShowSpinner("loadVendorReturn");
    this.purchaseService
      .updateVendorReturn(isBaseCurrency, rmaData)
      .then(() => {
        this.appMainService.isHideSpinner("loadVendorReturn");
        this.isDisabledSaveBtn = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Vendor return updated successfully",
        });
        this.selectedBill = null;
        this.selectedLocation = null;
        this.selectedProductListTable = null;
        this.uploadedAttachments = [];
        this.selectedAttachments = [];
        this.subtotal = 0;
        this.totalRefund = 0;
        this.rmaDetailsText = "";
        this.disableBillChange = false;
        this.onVendorRmaSaveComplete.emit(true);
      })
      .catch(() => {
        this.isDisabledSaveBtn = false;
        this.appMainService.isHideSpinner("loadVendorReturn");
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error occurred while saving Vendor return",
        });
      });
  }

  getVendorReturnCreateModel(value, customAttributes) {
    let customerRmaObj: IVendorRma = {
      id: this.type == DialogType.EDIT ? this.vendorReturnDetails?.id : 0,
      createdSource: this.type == DialogType.EDIT ? this.vendorReturnDetails.createdSource : this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.type == DialogType.EDIT ? this.vendorReturnDetails.createdBy : this.app.user.userId,
      updatedBy: this.app.user.userId,
      createdDate: this.type == DialogType.EDIT ? this.vendorReturnDetails.createdDate : this.app._saveDateTimeWithZone(new Date()),
      updatedDate: this.app._saveDateTimeWithZone(new Date()),
      number: this.type == DialogType.EDIT ? this.vendorReturnDetails.number : "",
      description: value.description,
      organizationId: this.app.companyId,
      channelId: 1, //value.channelId?.id,
      vendorId: value.vendorId?.id, //
      warehouseId: value.warehouseId?.id,
      orderLocationId: this.selectedLocation?.id,
      userId: this.type == DialogType.EDIT ? this.vendorReturnDetails.createdBy : this.app.user.userId,
      totalAmount: this.subtotal * this.vendorExchangeRate,//excangeRate
      netAmount: this.subtotal * this.vendorExchangeRate,//excangeRate
      refundAmount: this.totalRefund * this.vendorExchangeRate,//excangeRate
      currencyUnitId: this.vendorDetails?.currencyId,//this.vendorReturnDetails?.currencyId ?? 
      exchangeRate: (this.orgCurrency?.find(cr => cr.currencyId == this.vendorDetails?.currencyId)?.exchangeRate ?? 0),
      statusId: 1,
      rmaStatusId: this.type == DialogType.CREATE ? 1 : this.vendorReturnDetails?.rmaStatusId,
      rmaStageId: this.type == DialogType.CREATE ? 1 : this.vendorReturnDetails?.rmaStageId,
      rmaTypeId: value.rmaTypeId?.id,
      rmaReasonId: value.rmaReasonId?.id,
      referenceNumber: "",
      billOrderId: this.selectedBill?.id, //
      rmaDate: this.app._saveDateTimeWithZone(new Date()),
      configJSON: JSON.stringify(this.vendorReturnTemplate),
      vendorRMANotes: [],
      vendorRMAProduct: [],
      customAttributeValues: this.type == DialogType.CREATE ? this.setCustomAttributes(customAttributes) : this.setExistingCustomAttributes(customAttributes),
      vendorRMAAttachment: this.type == DialogType.CREATE ? this.uploadedAttachments : this.setExistingFiles(this.uploadedAttachments),
      postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : (this.type == 'EDIT' ? this.vendorReturnDetails?.postingDate : this.app._saveDateTimeWithZone(new Date())),
      postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (this.type == 'EDIT' ? this.vendorReturnDetails?.postingMonth :  new Date().getMonth() + 1),
      postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (this.type == 'EDIT' ? this.vendorReturnDetails?.postingYear : new Date().getFullYear())
    };
    customerRmaObj.vendorRMAProduct = this.getVendorRmaProducts(customerRmaObj);
    return customerRmaObj;
  }

  setExistingFiles(newFiles) {
    let files = newFiles;
    for (let file of this.uploadedFiles) {
      const fileObj = {
        attachmentId: file.attachmentId,
        attachmentName: file.attachmentName,
        extension: file.extension,
        uploadedBy: file.uploadedBy,
        uploadedDate: file.createdDate,
      };
      files.push(fileObj);
    }
    return files;
  }

  setCustomAttributes(value) {
    const custom = [];
    if (value.length > 0) {
      value?.forEach((element) => {
        const customEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: this.app._saveDateTimeWithZone(new Date()),
          updatedDate: this.app._saveDateTimeWithZone(new Date()),
          objectId: this.app.preLoadedObjects.find((obj) => obj?.name == "VendorReturns").id,
          objectValue: 0,
          customAttributeId: element.id,
          customAttribute: this.modifyCustumAttributes(element),
          value: element.formControl?.name == "InputBox" || element.formControl?.name == "Number" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" ? element.value : null,
          statusId: 1,
          status: null,
          values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
          multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
          ratingId: element.formControl?.name == "Rating" ? element.value : 0,
          toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
          customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
        };
        custom.push(customEach);
      });
    }
    return custom;
  }
  setCheckBoxValue(value) {
    const checkBox = [];
    value?.forEach((element) => {
      const val = { name: element };
      checkBox.push(val);
    });
    return checkBox;
  }

  modifyCustumAttributes(data) {
    if (data.pickListValues) {
      data.pickListValues = JSON.stringify(data.pickListValues);
    }
    return data;
  }

  setExistingCustomAttributes(value) {
    const custom = [];
    if (value.length > 0) {
      value?.forEach((element) => {
        const customEach = {
          id: this.vendorReturnDetails?.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0] ? this.vendorReturnDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]?.id : 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: this.app._saveDateTimeWithZone(new Date()),
          updatedDate: this.app._saveDateTimeWithZone(new Date()),
          objectId: this.app.preLoadedObjects.find((obj) => obj?.name == "VendorReturns")?.id,
          objectValue: this.vendorReturnDetails.id,
          customAttributeId: element.id,
          customAttribute: this.modifyCustumAttributes(element),
          value: element.formControl?.name == "InputBox" || element.formControl?.name == "Number" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" ? element.value : null,
          statusId: 1,
          status: null,
          values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
          multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
          ratingId: element.formControl?.name == "Rating" ? element.value : 0,
          toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
          customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
        };
        custom.push(customEach);
      });
    }
    return custom;
  }

  getVendorRmaProducts(vendorRmaObj: IVendorRma): VendorRmaProduct[] {
    let selectedProductsForRma: VendorRmaProduct[] = [];
    this.selectedProductListTable?.forEach((product) => {
      const rmaProduct = new VendorRmaProduct(this.app, this.type, this.vendorReturnDetails);
      rmaProduct.id = this.type == DialogType.EDIT ? this.vendorReturnDetails?.vendorRMAProduct?.filter((prd) => prd.productId == product.productId).map((prdObj) => prdObj.id)[0] : 0;
      rmaProduct.customerRMAId = vendorRmaObj.id;
      rmaProduct.description = product.description;
      rmaProduct.productId = product.productId;
      rmaProduct.warrantyPeriod = this.app._saveDateTimeWithZone(new Date());
      rmaProduct.warrantyTypeId = product.warrantyTypeId;
      rmaProduct.warranty = product.warranty;
      rmaProduct.shippedQuantity = product.qty;
      rmaProduct.binId = product.binId;
      rmaProduct.returnQuantity = product.returnQty;
      rmaProduct.approvedQuantity = 0;
      rmaProduct.productUOMId = product.productUOMId;
      rmaProduct.pricePerProduct = product.rate * this.vendorExchangeRate;//excangeRate;
      rmaProduct.totalAmount = product.returnAmount * this.vendorExchangeRate;//excangeRate
      rmaProduct.billOrderId = product.billOrderId;
      rmaProduct.statusId = 1;
      rmaProduct.vendorRMAProductSerialDetail = product.vendorRMAProductSerialDetail;
      selectedProductsForRma.push(rmaProduct);
    });

    return selectedProductsForRma;
  }

  async processReturnDetails(res) {
    this.returnForm.patchValue(res);
    this.vendorReturnTemplate = res.configJSON ? JSON.parse(res.configJSON) : this.vendorReturnTemplate;
    const filteredrmaTypeId = this.allReturnTypes?.find((type) => type.id == res.rmaTypeId);
    this.returnForm?.controls["rmaTypeId"].setValue(filteredrmaTypeId);
    const filteredVendorId = this.allVendorsDD?.find((ven) => ven.id == this.vendorReturnDetails?.vendorId);
    this.returnForm?.controls["vendorId"].setValue(filteredVendorId);
    const filteredReasonId = this.allReasons?.find((reason) => reason.id == res.rmaReasonId);
    this.returnForm?.controls["rmaReasonId"].setValue(filteredReasonId);
    for (let prd of res?.vendorRMAProduct) {
      prd.typeId = prd.product?.typeId;
      prd.itemNo = prd.product?.itemNo;
      prd.returnQty = prd?.returnQuantity;
      prd.rate = prd?.pricePerProduct;
      prd.qty = prd?.shippedQuantity;
      prd.returnAmount = prd?.totalAmount;
      prd.amount = prd?.totalAmount;
      prd.uom = prd?.productUOM?.uomDetail?.name;
    }

    this.selectedProductListTable = [...res?.vendorRMAProduct].map((ele) => ({
      ...ele,
      rate: ele?.rate !== undefined ? parseFloat(ele?.rate).toFixed(this.length) : ele?.rate,
      amount: ele?.amount !== undefined ? parseFloat(ele?.amount).toFixed(this.length) : ele?.amount,
      returnAmount: ele?.returnAmount !== undefined ? parseFloat(ele?.returnAmount).toFixed(this.length) : ele?.returnAmount,
    }));
    this.uploadedFiles = [];
    res.vendorRMAAttachment?.forEach((element) => {
      this.uploadedFiles.push(element);
    });
    if (res.vendorId > 0 && res.orderLocationId > 0) {
      this.showAddProduct = true;
    }
    if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
      const filteredWarehouseId = this.rmaLocations?.find((loc) => loc.id == this.vendorReturnDetails?.warehouseId);

      this.returnForm?.controls["warehouseId"].setValue(filteredWarehouseId);
    }
    this.selectedBill = { id: res.billOrderId, number: res.number, name: res.number };
    this.calculateSubTotalAmount();
    this.calculateTotalRefundAmount();
    this.updateTotals();

    //populate saved custom field data
    Object.keys(this.customFields)?.forEach((key) => {
      const dataArr = this.customFields[key];
      if (dataArr && dataArr.length > 0) {
        dataArr?.forEach((element) => {
          const filteredCustom = this.vendorReturnDetails?.customAttributeValues?.filter((c) => c.customAttributeId == element.id)[0];

          if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
            element.value = filteredCustom.value;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
            element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
          } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
            element.customUploadedFiles = [];
            filteredCustom.customeAttachement?.forEach((el) => {
              element.customUploadedFiles.push(el);
            });
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
            element.value = filteredCustom.ratingId;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
            element.value = filteredCustom.toggle;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
            element.value = filteredCustom.values;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
            element.value = filteredCustom.values.name;
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
            element.value = [];
            filteredCustom.multipleValues?.forEach((el) => {
              element.value.push(el.name);
            });
          } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
            element.value = [];
            filteredCustom.multipleValues?.forEach((el) => {
              element.value.push(el);
            });
          }
        });
      }
    });
    if (this.type == DialogType.VIEW) {
      this.returnForm.disable();
    }
  }

  initializeVendorReturn(id) {
    this.initReturnForm();
    this.purchaseService.getVendorReturnDetails(id).subscribe(async (res) => {
      this.getSelectedVendorDetails(res?.vendor.id);
      this.vendorReturnDetails = res;
      this.currentPostingPeriodInfo = {
        postingDate: this.app._showDateTimeWithZone(this.vendorReturnDetails?.createdDate),
        postingMonth: this.vendorReturnDetails?.postingMonth,
        postingYear: this.vendorReturnDetails?.postingYear
      }

      this.closingDate = this.app._showDateTimeWithZone(new Date(this.vendorReturnDetails?.createdDate))
      this.getCustomFieldList("edit");
      await this.processReturnDetails(res);
    });
  }
  checkValue(event: KeyboardEvent, product) {
    const inputValue = parseFloat((event.target as HTMLInputElement).value);
    if ((product?.pendingRMAQty && inputValue > product.pendingRMAQty) || (!product?.pendingRMAQty && inputValue > product.qty)) {
      this.messageService.add({ severity: "error", summary: "Error", detail: "Return quantity cannot exceed available quantity...." });
    }
  }

  calReturnAmt(product) {
    product.returnAmount = this.roundToTwoDecimal(product.returnQty * product.rate);
    this.calculateSubTotalAmount();
    this.calculateTotalRefundAmount();
    this.updateTotals();
  }

  setTableCheck() {
    for (let s of this.autoGenerateLists) {
      if (this.allChecked) {
        s.checked = true;
      } else {
        s.checked = false;
      }
    }
  }

  setMainHeaderTracking() {
    const checked = this.nameLists.filter((ch) => ch.checked);
    if (checked.length == this.nameLists?.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  removeNumber(i) {
    this.autoGenerateLists.splice(i, 1);
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength--;
    this.totalTBRecord = this.listLength;
    const returnQty = this.selectedProductForScan.returnQty
    this.trackingForm.controls['qty'].setValue(returnQty - this.listLength);
    this.unMatchedSerials = this.autoGenerateLists?.filter(sr => !sr.systemPresent);
  }
  //Import
  openImport() {
    this.displayImport = true;
  }
  hideImport() {
    this.displayImport = false;
  }

  importSerialData(data) {
    this.unMatchedSerials = [];
    for (let dt of data.list) {
      if (dt.serialNo) {
        const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == dt.serialNo);
        if (present) {
          dt.systemPresent = true;
          dt.remove = false;
          dt.checked = false;
        } else if (!present && this.serialConfig?.enabled) {
          dt.systemPresent = false;
          dt.remove = false;
          dt.checked = true;
        } else if (!present || !this.serialConfig?.enabled) {
          dt.systemPresent = true;
          dt.checked = false;
        }
      } else {
        dt.systemPresent = true;
        dt.remove = false;
        dt.checked = false;
      }
      //this.autoGenerateLists.push(dt); /*new logic*/
      if (data.action == 'add') {
        const index = this.autoGenerateLists?.findIndex((exp) => exp.serialNo == dt.serialNo);
        if (index > -1) {
          dt.id = this.autoGenerateLists[index].id;
          this.autoGenerateLists[index] = dt;
        } else {
          if (this.listLength < this.selectedProductForScan?.returnQty) {
            this.autoGenerateLists.push(dt);
            this.listLength++;
          }
        }
      } else {
        // Get the total quantity from the form control
        const totalQty = this.selectedProductForScan.returnQty || 0;
        const filteredList = data.list?.slice(0, totalQty);
        // Fields to skip when comparing
        const skipKeys = ['id', 'expiration', 'field1', 'field2', 'field3', 'field4', 'field5', 'field6', 'field7', 'field8',
          'field9', 'field10', 'field11', 'field12', 'field13', 'field14', 'field15', 'field16', 'field17', 'field18', 'field19',
          'field20'
        ];
        // Compare only defined + non-empty fields from newItem against existingItem
        const isMatch = (existingItem: any, newItem: any): boolean => {
          for (const key in newItem) {
            if (skipKeys.includes(key)) continue;

            const newVal = newItem[key];
            if (newVal !== undefined && newVal !== null && newVal !== '') {
              if (existingItem[key] !== newVal) return false;
            }
          }
          return true;
        };
        // Step 1: Update existing items
        let updatedList = this.autoGenerateLists.map(existingItem => {
          const match = filteredList.find(newItem => isMatch(existingItem, newItem));
          if (match) {
            return {
              ...existingItem,
              ...Object.keys(match).reduce((acc, key) => {
                acc[key] = match[key] !== undefined && match[key] !== ''
                  ? match[key]
                  : existingItem[key]; // preserve existing if new is blank
                return acc;
              }, {} as any)
            };
          }
          return existingItem;
        });
        // Step 2: Remove items not found in filteredList
        updatedList = updatedList.filter(existingItem =>
          filteredList.some(newItem => isMatch(existingItem, newItem))
        );
        // Step 3: Add new items not present in updatedList
        filteredList.forEach(newItem => {
          const exists = updatedList.some(existingItem => isMatch(existingItem, newItem));
          if (!exists) {
            updatedList.push(newItem);
          }
        });
        this.autoGenerateLists = updatedList;
      }
      this.unMatchedSerials = this.autoGenerateLists?.filter((sr) => !sr.systemPresent);
    }
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength = this.autoGenerateLists.length;
    this.totalTBRecord = this.listLength;
    this.disabledSave = false;
    this.displayImport = false;
    this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.returnQty - this.listLength);
    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "Import successfully, removed duplicate Serial No.",
    });
  }

  importSave(data) {
    this.refId = data.referenceId;
    //duplicate file import
    const unique = data.list?.filter((obj) => {
      const autoIndex = this.autoGenerateLists.findIndex(item => item.serialNo === obj.serialNo);
      const hasBlankSerialNo = this.autoGenerateLists.some(item => item.serialNo === "");
      return autoIndex === -1 || hasBlankSerialNo;
    }) || [];

    const qty = (this.selectedProductForScan?.returnQty - this.listLength);
    if (unique.length > 0 && (data.list?.length - unique.length) > qty) {
      this.confirmationService.confirm({
        message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
        header: "Alert Confirmation",
        icon: "pi pi-info-circle",
        accept: () => {
          this.importSerialData(data);
        },
        reject: () => { },
      });
    } else {
      this.importSerialData(data);
    }
  }

  //open tracking list
  openTracking() {
    this.displayTracking = true;
  }

  closeTracking() {
    this.displayTracking = false;
  }

  saveTracking(data) {
    // Create a new object by adding the three fields
    for (let dt of data) {
      const newValue = {
        ...dt,          // Spread the existing data properties
        id: 0,
        systemPresent: true, // Add systemPresent field
        remove: false,       // Add remove field
        checked: false       // Add checked field
      };
      const presentSerialNo = this.autoGenerateLists?.find(nos => nos.serialNo == dt.serialNo);
      if (!presentSerialNo && this.listLength < this.selectedProductForScan?.returnQty) {
        this.autoGenerateLists.push(newValue);
        this.listLength = this.listLength + 1;
      }
    }
    this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
    this.nameLists = this.autoGenerateLists?.slice(0, 100);
    this.totalTBRecord = this.listLength;
    this.displayTracking = false;
  }
  onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
    this.updatedPostingPeriodInfo = postingInfo;
  }
  getIsetting() {
    this.appMainService.isShowSpinner("loadISettings");
    const iSettings = this.utilityService.getISettings();
    this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
    this.appMainService.isHideSpinner("loadISettings");
  }
}
